import React, { useRef } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { storyPanels } from '../../data/blackout';
export function StoryStrip() {
  const trackRef = useRef<HTMLDivElement>(null);
  const scrollTrack = (direction: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    track.scrollBy({
      left: direction * track.clientWidth * 0.8,
      behavior: 'smooth'
    });
  };
  return <section id="worlds" aria-label="Reality to story" className="border-y-2 border-bone/80 bg-obsidian py-12 md:py-16" data-id="element-326" data-mp="uyxlykcqkjb8">
      <div className="mx-auto mb-8 flex max-w-7xl items-end justify-between gap-6 px-5 md:px-8" data-id="element-327" data-mp="zzl9gw1rai0p">
        <div data-id="element-328" data-mp="l2ud6vndpmfb">
          <h2 className="font-display text-4xl uppercase leading-[0.95] text-bone md:text-6xl" data-id="element-329" data-mp="l3duqb94a8st">
            Step out of reality.
          </h2>
          <p className="mt-3 max-w-lg text-[15px] leading-relaxed text-steel" data-id="element-330" data-mp="2fesgkgz0bo3a">
            World 01 is the real one. World 02 is the story. The mask is the
            door between them.
          </p>
          <div className="mt-4 flex items-center gap-4 text-[10px] font-semibold uppercase tracking-[0.2em]" data-id="element-331" data-mp="x1nb3hbwp6g0">
            <span className="flex items-center gap-2 text-steel" data-id="element-332" data-mp="s2stujtl7py0">
              <span className="h-2.5 w-2.5 border border-bone/60" aria-hidden="true" data-id="element-333" data-mp="16t03ca1m9ymk" />
              Reality
            </span>
            <span className="flex items-center gap-2 text-bone" data-id="element-334" data-mp="11ugjqgahwyxd">
              <span className="h-2.5 w-2.5 bg-bone" aria-hidden="true" data-id="element-335" data-mp="e3kqdeqe5vo0" />
              The story
            </span>
          </div>
        </div>
        <div className="hidden shrink-0 gap-2 md:flex" data-id="element-336" data-mp="96auphcesnrq">
          <button type="button" onClick={() => scrollTrack(-1)} aria-label="Previous panels" className="flex h-11 w-11 items-center justify-center border border-gunmetal text-bone transition-colors duration-150 hover:border-bone" data-id="element-337" data-mp="n494e9fsbw0w">
            <ArrowLeft className="h-4 w-4" aria-hidden="true" data-id="element-338" data-mp="1uicmo2qnrn2l" />
          </button>
          <button type="button" onClick={() => scrollTrack(1)} aria-label="Next panels" className="flex h-11 w-11 items-center justify-center border border-gunmetal text-bone transition-colors duration-150 hover:border-bone" data-id="element-339" data-mp="1ukf96cslqy2k">
            <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-340" data-mp="1138j99nmcqia" />
          </button>
        </div>
      </div>

      <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory gap-2 overflow-x-auto scroll-px-5 px-5 md:gap-3 md:scroll-px-8 md:px-8" data-id="element-341" data-mp="154u0f776rqya">
        {storyPanels.map((panel, i) => {
        const isStory = panel.world === 'story';
        return <figure key={panel.id} className={`relative aspect-[3/4] w-[70vw] max-w-[300px] shrink-0 snap-start overflow-hidden bg-carbon md:w-[280px] ${isStory ? 'border-[3px] border-bone' : 'border border-gunmetal'}`} data-id="element-342" data-mp="hg2euyo3q6uh" data-mpi={i}>
              <img src={panel.image} alt={panel.alt} loading="lazy" className={`absolute inset-0 h-full w-full object-cover ${isStory ? '' : 'grayscale contrast-125'}`} data-id="element-343" data-mp="3pvchc7vwle2s" />
              {!isStory && <div className="grain absolute inset-0" aria-hidden="true" data-id="element-344" data-mp="39b50tnhnwrqx" />}

              <div className="absolute left-2.5 right-2.5 top-2.5 flex items-start justify-between gap-2" data-id="element-345" data-mp="34d3gz0cewoee">
                <span className="bg-obsidian px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-bone" data-id="element-346" data-mp="2zgd2ghg9a0v3">
                  {String(i + 1).padStart(2, '0')} · {panel.chapter}
                </span>
                <span className={`px-1.5 py-1 text-[9px] font-semibold uppercase tracking-[0.18em] ${isStory ? 'bg-bone text-obsidian' : 'border border-bone/60 bg-obsidian/70 text-bone/85'}`} data-id="element-347" data-mp="2pp8mbeeug9yo">
                  {isStory ? 'The story' : 'Reality'}
                </span>
              </div>

              <figcaption className={`absolute bottom-2.5 left-2.5 right-2.5 px-2.5 py-2 text-[12px] font-bold uppercase leading-tight tracking-[0.06em] ${isStory ? 'border-2 border-obsidian bg-bone text-obsidian' : 'bg-obsidian/85 text-bone'}`} data-id="element-348" data-mp="fo5vq0lzi3tq">
                {panel.caption}
              </figcaption>
            </figure>;
      })}
      </div>
    </section>;
}